import * as types from '../mutation-types'

const state = {
  authenticated: false,
  timesheetPage: false,
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  },
  eventCount: 0,
  timesheetStatus: {},
  datetimemytimesheet: null,
  datetimeotstatus: null,
  datetimetotalot: null,
  datetimetimesheetlist: null,
  allowanceSwitch: "family"
}

const mutations = {
  [types.AUTHENTICATED] (state, success) {
    state.authenticated = success
  },

  [types.TIMESHEET_PAGE] (state, success) {
    state.timesheetPage = success
  },

  [types.TOGGLE_DEVICE] (state, device) {
    state.device.isMobile = device === 'mobile'
    state.device.isTablet = device === 'tablet'
  },

  [types.TOGGLE_SIDEBAR] (state, opened) {
    if (state.device.isMobile) {
      state.sidebar.opened = opened
    } else {
      state.sidebar.opened = true
    }
  },

  [types.SWITCH_EFFECT] (state, effectItem) {
    for (let name in effectItem) {
      state.effect[name] = effectItem[name]
    }
  },

  [types.EVENT_COUNT] (state) {
    state.eventCount++
  },

  [types.TIMESHEET_STATUS] (state, timesheet) {
    state.timesheetStatus = timesheet
  },

  [types.DATETIME_TIMESHEET] (state, datetime) {
    state.datetimemytimesheet = datetime
  },

  [types.DATETIME_OTSTATUS] (state, datetime) {
    state.datetimeotstatus = datetime
  },

  [types.DATETIME_TOTALOT] (state, datetime) {
    state.datetimetotalot = datetime
  },

  [types.DATETIME_TIMESHEETLIST] (state, datetime) {
    state.datetimetimesheetlist = datetime
  },
  
  [types.ALLOWANCE_SWITCH] (state, value) {
    state.allowanceSwitch = value
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/app.js